import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useExpirationFilter } from './useExpirationFilter';

export const ExpirationFilter = ({ value, setFilters, expirationOptions }) => {
  const { formSchema, onSubmit } = useExpirationFilter({
    setFilters,
  });

  const selectedOption = expirationOptions.find((i) => i.value === value) ?? expirationOptions[0];
  return (
    <Formik
      initialValues={{ expirationWithin: selectedOption || '' }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="expirationWithin"
          label="Expiration date"
          placeholder="Expiration"
          size="small"
          component={FormSelect}
          options={expirationOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

ExpirationFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
  expirationOptions: PropTypes.array.isRequired,
};

ExpirationFilter.defaultProps = {
  value: '',
};
